export class EnvironmentConfig {
  production: string;
  adminApiDomain: string;
  assetsApiDomain: string;
  commerceProductsApiDomain?: string;
  inspectionsApiDomain: string;
  ordersApiDomain: string;
  transportationApiDomain: string;
  identityProvider: string;
  clientLoginRedirectUri: string;
  clientLogoutRedirectUri: string;
  clientSilentLoginRedirectUri: string;
  clientId: string;
  appInsightsKey: string;
  azureSearchKey: string;
  azureSearchUrl: string;
  azureMapKey: string;
  baseImagePath: string;
  enableLiveChat: string;
  loginRedirect: string;
  helloSignClientId: string;
  routePrefix: string;
  gtmId: string;
  googleAnalyticsId: string;
  identityScope: string;
  buildId: string;
  hostnamePrefix: string;
  logLevel?: string;
  stripeKey: string;
  openAiApiKey: string;
  promptFlowUrl: string;
  mapboxKey: string;
  sanityProjectId: string;
  sanityDataset: string;
  sanityApiVersion: string;
  sanityUseCdn: string;
  googleCustomSearchApiKey: string;
  googleCustomSearchEngineId: string;
  /** Shop storefront entry points on the rental pages. Off unless the hostname block sets "true". */
  storefrontEnabled?: string;
  /** Comma-separated live Shop machine types. Empty follows production Phase 1 or every phased type. */
  shopLiveMachineTypes?: string;
}

export function isStorefrontEnabled(config: Partial<EnvironmentConfig> | undefined): boolean {
  return config?.storefrontEnabled === "true";
}
